import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, normalizeClass as _normalizeClass, vModelText as _vModelText, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../static/images/logo.png'
import _imports_1 from '../../static/images/search.png'
import _imports_2 from '../../static/images/close.png'
import _imports_3 from '../../static/images/search1.png'


const _withScopeId = n => (_pushScopeId("data-v-0978c499"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "left" }
const _hoisted_2 = { class: "logo" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_4 = { class: "pc-nav" }
const _hoisted_5 = ["data-route", "onMouseenter", "onMouseleave"]
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "child" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { class: "right" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  class: "s gd"
}, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bar gd" }, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bar gd" }, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bar gd" }, null, -1))
const _hoisted_18 = [
  _hoisted_15,
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = { class: "wap-nav" }
const _hoisted_20 = ["href"]
const _hoisted_21 = {
  key: 3,
  class: "child"
}
const _hoisted_22 = {
  key: 4,
  class: "child"
}
const _hoisted_23 = {
  key: 5,
  class: "child"
}
const _hoisted_24 = { class: "search-box" }
const _hoisted_25 = { class: "sub" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "",
  class: "icon"
}, null, -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "zhanwei" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_router_link, { to: "/" }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          })
        ]),
        _createElementVNode("nav", _hoisted_4, [
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navlist, (item) => {
              return (_openBlock(), _createElementBlock("li", {
                "data-route": item.route,
                key: item.id,
                onMouseenter: ($event: any) => (item.show = !item.show),
                onMouseleave: ($event: any) => (item.show = false)
              }, [
                (item.id == 13)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: { path: item.route, query: {id: item.sonlist[0].id} }
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  : (item.id == 20)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        href: item.text,
                        target: "_blank"
                      }, _toDisplayString(item.name), 9, _hoisted_6))
                    : (_openBlock(), _createBlock(_component_router_link, {
                        key: 2,
                        to: item.route
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"])),
                _createVNode(_Transition, { name: "el-zoom-in-top" }, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("div", _hoisted_7, [
                      (item.id == 8)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.sonlist, (child) => {
                              return (_openBlock(), _createBlock(_component_router_link, {
                                to: { path: '/product-detail/' + child.id },
                                key: child.id
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(child.title), 1)
                                ]),
                                _: 2
                              }, 1032, ["to"]))
                            }), 128))
                          ]))
                        : (item.id == 13)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.sonlist, (child) => {
                                return (_openBlock(), _createBlock(_component_router_link, {
                                  to: { path: item.route, query: {id: child.id} },
                                  key: child.id
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(child.name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"]))
                              }), 128))
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.sonlist, (child) => {
                                return (_openBlock(), _createBlock(_component_router_link, {
                                  to: child.route,
                                  key: child.id
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(child.name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"]))
                              }), 128))
                            ]))
                    ], 512), [
                      [_vShow, item.sonlist.length > 0 && item.show]
                    ])
                  ]),
                  _: 2
                }, 1024)
              ], 40, _hoisted_5))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", {
          class: "search-btn",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openSearchBox && _ctx.openSearchBox(...args)))
        }, _hoisted_14),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.menuShow ? 'menu ed' : 'menu'),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.menuShow = !_ctx.menuShow))
        }, _hoisted_18, 2)
      ])
    ]),
    _createVNode(_Transition, { name: "el-zoom-in-top" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("nav", _hoisted_19, [
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navlist, (item) => {
              return (_openBlock(), _createElementBlock("li", {
                key: item.id
              }, [
                (item.id == 13)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: { path: item.route, query: {id: item.sonlist[0].id} }
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  : (item.id == 20)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        href: item.text,
                        target: "_blank"
                      }, _toDisplayString(item.name), 9, _hoisted_20))
                    : (_openBlock(), _createBlock(_component_router_link, {
                        key: 2,
                        to: item.route
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"])),
                (item.id == 8)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.sonlist, (child) => {
                        return (_openBlock(), _createBlock(_component_router_link, {
                          to: { path: '/product-detail/' + child.id },
                          key: child.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(child.title), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"]))
                      }), 128))
                    ]))
                  : (item.id == 13)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.sonlist, (child) => {
                          return (_openBlock(), _createBlock(_component_router_link, {
                            to: { path: item.route, query: {id: child.id} },
                            key: child.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(child.name), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"]))
                        }), 128))
                      ]))
                    : _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_23, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.sonlist, (child) => {
                          return (_openBlock(), _createBlock(_component_router_link, {
                            to: child.route,
                            key: child.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(child.name), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"]))
                        }), 128))
                      ], 512)), [
                        [_vShow, item.sonlist.length > 0]
                      ])
              ]))
            }), 128))
          ])
        ], 512), [
          [_vShow, _ctx.menuShow]
        ])
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "el-zoom-in-top" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _hoisted_26,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.value) = $event)),
              placeholder: "输入关键字搜索",
              onKeyup: _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.SearchEnter && _ctx.SearchEnter(...args)), ["enter"]))
            }, null, 544), [
              [_vModelText, _ctx.value]
            ]),
            _createElementVNode("div", {
              class: "btn",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.Search && _ctx.Search(...args)))
            }, "搜索")
          ])
        ], 512), [
          [_vShow, _ctx.searcShow]
        ])
      ]),
      _: 1
    }),
    _withDirectives(_createElementVNode("div", {
      class: "search-meng",
      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.closeSearchBox && _ctx.closeSearchBox(...args)))
    }, null, 512), [
      [_vShow, _ctx.searcShow]
    ]),
    _hoisted_27
  ], 64))
}